<template>
    <div class="animated fadeIn dashboard-comercial">
      <app-objetivos-mensuales 
        ref="objetivosMensuales"
        :consultarRentabilidadBrutaReal="false">
      </app-objetivos-mensuales>
      
      <hr class="dashboard">

      <b-row>
        <b-col sm="6" lg="4">
          <app-indicador-ventas
            ref="indicadorVentas"
            :totalNegocio="false"
            :accesoActualizar="actualizarResultados">
          </app-indicador-ventas>
        </b-col>

        <b-col sm="6" lg="4">
          <app-indicador-rentabilidad-bruta
            ref="indicadorRentabilidadBruta"
            :totalNegocio="false"
            :accesoExportar="consultarPresupuestosRB"
            :accesoActualizar="actualizarResultados">
          </app-indicador-rentabilidad-bruta>
        </b-col>
      </b-row>
     
      <app-mensaje
        :modalMsj="modalMsj"
        :modalMensaje="modalMensaje"
        @okAction="okAction"
        @hiddenAction="hiddenAction">
      </app-mensaje>
    </div>
</template>

<script>
import IndicadorVentas from './IndicadorVentas';
import IndicadorRentabilidadBruta from './IndicadorRentabilidadBruta';
import ObjetivosMensuales from './comercial/ObjetivosMensuales';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  components: {
    appIndicadorVentas: IndicadorVentas,
    appIndicadorRentabilidadBruta: IndicadorRentabilidadBruta,
    appObjetivosMensuales: ObjetivosMensuales,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],

data() {
    return {
      key: 0,

      actualizarResultados: false,
      consultarPresupuestosRB: false
    }
  },
  created() {
    this.actualizarResultados = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardActualizarResultados'));
    this.consultarPresupuestosRB = Boolean(this.$store.getters['user/tieneAccesoModulo']('DashboardIndicadorRBConsultarPresupuestos'));
  },
  methods: {
    getIndicadores(incluirObjetivosMensuales) {
      this.$store.dispatch('resultadosVentas/inicializarVentas')
        .then(() => this.$refs.indicadorVentas.getIndicador());

      this.$store.dispatch('resultadosRentabilidadBruta/inicializar')
        .then(() => this.$refs.indicadorRentabilidadBruta.getIndicador());

      if (incluirObjetivosMensuales) {
        this.$refs.objetivosMensuales.getResultados();
      // } else {
      //   this.$refs.objetivosMensuales.loadGrilla();
      }
    }
  }
}
</script>

<style>
  .dashboard-comercial .row {
    margin-bottom: 30px;
  }
  .dashboard-comercial .dashboard-chart > div {
    position: relative;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 10%;    
  }
  .dashboard-comercial .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .dashboard-chart .description {
    font-size: 12px;
    font-style: italic;
  }
</style>


